import React from 'react';
var ClipPath = function (_a) {
    var id = _a.id, area = _a.area;
    return (React.createElement("clipPath", { id: id },
        React.createElement("path", { d: area })));
};
export default ClipPath;
